import React from 'react';
import { describeTimeTick } from '../../utils/histogramTimeAxis';

/** Three-layer x tick: Sunday day / month / year (month + year when they change). */
export default function HistogramTimeTick({ x, y, payload, index }) {
  const layers = describeTimeTick(payload?.value, index);
  if (!layers || x == null) return null;
  const twoLayer = layers.kind !== 'week';
  return (
    <g transform={`translate(${x},${y})`}>
      <text dy={12} textAnchor="middle" fill="#64748b" fontSize={10}>
        {layers.top}
      </text>
      <text dy={26} textAnchor="middle" fill="#475569" fontSize={10} fontWeight={600}>
        {layers.showMid ? layers.mid : ''}
      </text>
      {!twoLayer && (
        <text dy={40} textAnchor="middle" fill="#0f172a" fontSize={11} fontWeight={700}>
          {layers.showBot ? layers.bot : ''}
        </text>
      )}
    </g>
  );
}
